export default [
  {
    key: 'adName',
    title: '计划名称',
    fixed: 'left',
    width: 46,
    overflow: true
  },
  {
    key: 'imageDetailName',
    title: '素材',
    width: 108,
    overflow: true
  },
  {
    key: 'mediaName',
    title: '媒体',
    width: 80,
    overflow: true
  },
  {
    key: 'accountName',
    title: '账号',
    width: 70
  },
  {
    key: 'opNames',
    title: '管理人员',
    overflow: true
  },
  {
    key: 'opType',
    title: '操作类型'
  },
  {
    key: 'execStatus',
    title: '状态',
    overflow: true,
    width: 120
  },
  {
    key: 'lastOperateTime',
    title: '最后操作时间',
    width: 60
  },
  {
    key: 'control',
    title: '操作',
    width: 52
  }
]
